export const GET_MAIN_CONFIG = '@@reports/GET_MAIN_CONFIG';
export const GET_MAIN_CONFIG_SUCCESS = '@@reports/GET_MAIN_CONFIG_SUCCESS';
export const GET_MAIN_CONFIG_ERROR = '@@reports/GET_MAIN_CONFIG_ERROR';

export const GET_PAGE_CONFIG = '@@reports/GET_PAGE_CONFIG';
export const GET_PAGE_CONFIG_SUCCESS = '@@reports/GET_PAGE_CONFIG_SUCCESS';
export const GET_PAGE_CONFIG_ERROR = '@@reports/GET_PAGE_CONFIG_ERROR';

export const SET_PAGE_FILTERS = '@@reports/SET_PAGE_FILTERS';
export const SET_PAGE_FILTERS_TYPE = '@@reports/SET_PAGE_FILTERS_TYPE';
export const SET_PAGE_FILTERS_QUERY = '@@reports/SET_PAGE_FILTERS_QUERY';
export const SET_PAGE_DATA = '@@reports/SET_PAGE_DATA';

export const GET_USERS_LIST_SEARCH = '@@reports/GET_USERS_LIST_SEARCH';
export const GET_USERS_LIST_SEARCH_SUCCESS = '@@reports/GET_USERS_LIST_SEARCH_SUCCESS';
export const GET_USERS_LIST_SEARCH_ERROR = '@@reports/GET_USERS_LIST_SEARCH_ERROR';

export const SET_PAGE_LOADER = '@@reports/SET_PAGE_LOADER';

export const SET_PAGE_CLEAR_PAGE_DATA = '@@reports/SET_PAGE_CLEAR_PAGE_DATA';
